module.exports = __webpack_public_path__ + "assets/bgOzonMobile.791c4c3d8c5a12d55199728501e245a816472c9a450c1eee573a386f6a7ea0c2.jpg";